import Label from '../../../ui/Label'
import Loading from '../../../ui/Loading'
import { useMasterData } from '../../../../hooks/api/useMasterData'
import { selectNewProductAddOns, toggleAddOn } from '../../../../features/product/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { AddOnsData } from '../../../../features/setup/setupResponse';
// import { AddOns } from '../../../../types/oddons';

export default function ProdModAddOns() {

    const dispatch = useDispatch()
    const selectedAddOns = useSelector(selectNewProductAddOns);
    const { addOns, isLoadingAddOns, isErrorAddOns, errorMessageAddOns } = useMasterData()
    
    const activeProductAddOns = useMemo(() => {
        return addOns.filter((opt: AddOnsData) => opt.isActive);
    }, [addOns]);

    return (
        <div className=''>
            <Label label={'Select add-ons (optional)'}/>
            <div className='flex space-x-2'>
                { isLoadingAddOns ? (
                    <div className='flex justify-center items-center w-full'>
                        <Loading setH={'h-[20px]'}/>
                    </div>
                ) : isErrorAddOns ? (
                    <div className='flex justify-center items-center w-full'>
                        <p className={`text-red-500 text-xs`}>
                            {errorMessageAddOns}
                        </p>
                    </div>
                ) : (
                    <div className='w-full'>
                        <div className='grid grid-cols-2 gap-2'>
                            {activeProductAddOns.map((ons) => {
                                const isSelected = selectedAddOns?.some((item) => item.addonID === ons.addonID);
                                return (
                                    <div
                                        key={ons.addonID}
                                        onClick={() => dispatch(toggleAddOn(ons))}
                                        className={`border py-1 px-1.5 text-xs rounded cursor-pointer select-none transition-all 
                                            ${ isSelected ? "border-cbColor bg-orange-100 font-medium"
                                                : "border-gray-300 hover:border-gray-400"
                                            }
                                        `}
                                    >
                                        {ons.addonName}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
